import { render, staticRenderFns } from "./VimsEntryForm.vue?vue&type=template&id=3db56181&"
import script from "./VimsEntryForm.vue?vue&type=script&lang=js&"
export * from "./VimsEntryForm.vue?vue&type=script&lang=js&"
import style0 from "./VimsEntryForm.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports